module.exports = "<app-payor-date-range-report reportPath=\"CreateLcUtsReport\" isDateRange=\"true\" isExcel=\"true\" title=\"Report Logisticare Uts\" reportName=\"LogisticareUts\"> </app-payor-date-range-report>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manager-reports/logisticare-uts-report/logisticare-uts-report.component.html
// module id = 2465
// module chunks = 66